<!-- Export Certificate Format -->
<div class="export-certificate-container">
  <div class="certificate-page" *ngFor="let invoice of invoices; let i = index">

    <!-- Header Section -->
    <div class="certificate-header">
      <div class="header-left">
        <span class="exp-cert-label">EXP. CERT.</span>
      </div>
      <div class="header-right">
        <span class="print-label">Print All</span>
        <div class="company-prefix">COMPANY_PREFIX_ID NO.</div>
      </div>
    </div>

    <!-- Title Section -->
    <div class="certificate-title">
      <h1>EXPORT CERTIFICATE</h1>
    </div>

    <!-- Certificate Information -->
    <div class="certificate-info">
      <div class="cert-number-section">
        <div class="cert-field">
          <label>CERTIFICATE NO.</label>
          <input type="text" [value]="getCertificateNumber(invoice)" readonly>
        </div>
        <div class="vehicle-count" *ngIf="viewMode === 'merged' && invoice.vehicles">
          <span class="count-badge">{{ getVehicleCount(invoice) }} Vehicles</span>
        </div>
      </div>

      <div class="id-number-section">
        <div class="cert-field">
          <label>ID NO.</label>
          <input type="text" [value]="viewMode === 'merged' && invoice.vehicles ? 'MULTIPLE VEHICLES' : (invoice.vehicle?.chassis_no || '')" readonly>
        </div>

        <div class="date-fields">
          <div class="date-field">
            <label>YEAR</label>
            <input type="text" [value]="invoice.vehicle?.year || ''" readonly>
          </div>
          <div class="date-field">
            <label>MONTH</label>
            <input type="text" [value]="invoice.vehicle?.month || ''" readonly>
          </div>
          <div class="date-field">
            <label>DAY</label>
            <input type="text" [value]="getCurrentDay()" readonly>
          </div>
        </div>
      </div>
    </div>

    <!-- Main Certificate Table -->
    <div class="certificate-table-container">
      <table class="certificate-table">

        <!-- Vehicle Information Header -->
        <tr>
          <td class="table-header" colspan="2">MOTOR VEHICLE NUMBER</td>
          <td class="table-header" colspan="2">GRANT DATE</td>
          <td class="table-header" colspan="2">FIRST GRANT DATE</td>
          <td class="table-header" colspan="2">CLASSIFICATION OF VEHICLE</td>
          <td class="table-header">USE</td>
          <td class="table-header" colspan="3">LIGHT MOTOR VEHICLE INSPECTION ORGANIZATION</td>
        </tr>

        <!-- Vehicle Information Data - Individual Mode -->
        <tr *ngIf="viewMode !== 'merged' || !invoice.vehicles">
          <td colspan="2" class="table-data">{{ invoice.vehicle?.chassis_no || '' }}</td>
          <td class="table-data">YEAR</td>
          <td class="table-data">MONTH</td>
          <td class="table-data">DAY</td>
          <td class="table-data">YEAR</td>
          <td class="table-data">MONTH</td>
          <td class="table-data">DAY</td>
          <td class="table-data">
            <select>
              <option>Private</option>
              <option>Commercial</option>
            </select>
          </td>
          <td class="table-data">PURPOSE</td>
          <td class="table-data">TYPE OF BODY</td>
        </tr>

        <!-- Vehicle Information Data - Merged Mode -->
        <tr *ngIf="viewMode === 'merged' && invoice.vehicles">
          <td colspan="2" class="table-data merged-vehicles">
            <div *ngFor="let vehicle of invoice.vehicles; let idx = index" class="vehicle-item">
              <span>{{ idx + 1 }}. {{ vehicle.chassis_no }}</span>
            </div>
          </td>
          <td class="table-data">YEAR</td>
          <td class="table-data">MONTH</td>
          <td class="table-data">DAY</td>
          <td class="table-data">YEAR</td>
          <td class="table-data">MONTH</td>
          <td class="table-data">DAY</td>
          <td class="table-data">
            <select>
              <option>Private</option>
              <option>Commercial</option>
            </select>
          </td>
          <td class="table-data">PURPOSE</td>
          <td class="table-data">TYPE OF BODY</td>
        </tr>

        <!-- Additional Vehicle Details -->
        <tr>
          <td class="table-data">{{ invoice.vehicle?.year || '' }}</td>
          <td class="table-data">{{ invoice.vehicle?.month || '' }}</td>
          <td class="table-data">{{ getCurrentDate().split('/')[0] }}</td>
          <td class="table-data">{{ invoice.vehicle?.year || '' }}</td>
          <td class="table-data">{{ invoice.vehicle?.month || '' }}</td>
          <td class="table-data">{{ getCurrentDate().split('/')[0] }}</td>
          <td class="table-data">
            <select>
              <option>Car</option>
              <option>Truck</option>
              <option>Bus</option>
            </select>
          </td>
          <td class="table-data">
            <select>
              <option>Personal</option>
              <option>Business</option>
            </select>
          </td>
          <td class="table-data">OWNERSHIP</td>
          <td class="table-data">LENGTH</td>
          <td class="table-data">WIDTH</td>
          <td class="table-data">HEIGHT</td>
        </tr>

        <!-- Maker Information -->
        <tr>
          <td class="table-header" colspan="2">MAKER'S SERIAL NUMBER</td>
          <td class="table-header">FIXED NUMBER</td>
          <td class="table-header" colspan="2">MAXIMUM CARGO</td>
          <td class="table-header">WEIGHT</td>
          <td class="table-header">OWNERSHIP</td>
          <td class="table-header">LENGTH</td>
          <td class="table-header">WIDTH</td>
          <td class="table-header">HEIGHT</td>
        </tr>

        <!-- Maker Data -->
        <tr>
          <td colspan="2" class="table-data">{{ invoice.vehicle?.chassis_no || '' }}</td>
          <td class="table-data">{{ invoice.vehicle?.stock_no || '' }}</td>
          <td class="table-data">KG</td>
          <td class="table-data">KG</td>
          <td class="table-data">KG</td>
          <td class="table-data">KG</td>
          <td class="table-data">444</td>
          <td class="table-data">170</td>
          <td class="table-data">148</td>
        </tr>

        <!-- Vehicle Specifications -->
        <tr>
          <td class="table-header">TRADEMARK OF THE MAKER OF MOTOR VEHICLE</td>
          <td class="table-header">MODEL</td>
          <td class="table-header">ENGINE MODEL</td>
          <td class="table-header" colspan="2">CLASSIFICATION OF FUEL</td>
          <td class="table-header">ENGINE CAPACITY</td>
          <td class="table-header">F WEIGHT</td>
          <td class="table-header">R WEIGHT</td>
          <td class="table-header" colspan="3">SPECIFICATION CLASSIFICATION</td>
        </tr>

        <!-- Vehicle Specifications Data -->
        <tr>
          <td class="table-data">{{ invoice.vehicle?.make || '' }}</td>
          <td class="table-data">{{ invoice.vehicle?.model || '' }}</td>
          <td class="table-data">{{ invoice.vehicle?.engine || '' }}</td>
          <td class="table-data">Gasoline/Hybrid</td>
          <td class="table-data"></td>
          <td class="table-data">CC</td>
          <td class="table-data">KG</td>
          <td class="table-data">KG</td>
          <td colspan="3" class="table-data"></td>
        </tr>

        <!-- User Information -->
        <tr>
          <td class="table-header">TYPE OF USER</td>
          <td class="table-header" colspan="11">Imperial Solutions Ltd.</td>
        </tr>

        <tr>
          <td class="table-header">ADDRESS OF USER</td>
          <td class="table-data" colspan="11">2F-24 AOBADAI, KITAKU KOBE 651-1231, JAPAN</td>
        </tr>

        <tr>
          <td class="table-header">NAME OF OWNER</td>
          <td class="table-data" colspan="11">SAME AS USER</td>
        </tr>

        <tr>
          <td class="table-header">ADDRESS OF OWNER</td>
          <td class="table-data" colspan="11">SAME AS USER'S ADDRESS</td>
        </tr>

        <tr>
          <td class="table-header">LOCALITY OF PRINCIPAL PLACE OF USE</td>
          <td class="table-data" colspan="11">SAME AS USER'S ADDRESS</td>
        </tr>

        <tr>
          <td class="table-header">EXPORT SCHEDULED DAY</td>
          <td class="table-data">YEAR</td>
          <td class="table-data">MONTH</td>
          <td class="table-data">DAY</td>
          <td class="table-data" colspan="8">WE HEREBY CERTIFY THAT THE TRANSLATION TRUE AND CORRECT</td>
        </tr>

        <!-- Export Date -->
        <tr>
          <td class="table-data"></td>
          <td class="table-data">{{ invoice.vehicle?.year || '' }}</td>
          <td class="table-data">{{ invoice.vehicle?.month || '' }}</td>
          <td class="table-data">{{ getCurrentDate().split('/')[0] }}</td>
          <td class="table-data" colspan="8"></td>
        </tr>

      </table>
    </div>

    <!-- Company Logo and Signature Section -->
    <div class="signature-section">
      <div class="company-logo">
        <div class="logo-circle">
          <span class="logo-text">ISL</span>
        </div>
        <div class="company-info">
          <h3>Imperial Solutions</h3>
          <p>PROSPERITY FOR ALL</p>
        </div>
      </div>

      <div class="company-details">
        <p><strong>IMPERIAL SOLUTIONS LTD.</strong></p>
        <p>2F-24 AOBADAI</p>
        <p>KITAKU KOBE 651-1231, JAPAN</p>
        <p>PHONE: +81-78-201-5360</p>
      </div>

      <div class="signature-area">
        <div class="signature-stamp">
          <div class="stamp-placeholder">
            [STAMP]
          </div>
        </div>
        <div class="authorized-signature">
          <p><strong>AUTHORIZED SIGNATURE</strong></p>
          <p><strong>Imperial Solutions</strong></p>
          <p><strong>D.S SETHI</strong></p>
        </div>
      </div>
    </div>

    <!-- Footer -->
    <div class="certificate-footer">
      <div class="page-info">
        <span>Page No. 1</span>
      </div>
      <div class="save-pdf">
        <button class="save-pdf-btn">Save as PDF</button>
      </div>
    </div>

    <!-- Page Break (except for last invoice) -->
    <div class="page-break" *ngIf="i < invoices.length - 1"></div>

  </div>
</div>
